module.exports = __webpack_public_path__ + "static/media/pulverizador2.f25f96c9.svg";